// my script

$(document).ready(function () {
  $('.Calculate-btn').on('click', function(){
    let weight = $('.calculator .number-input').val();
    let breed = $('#dog-breed').val();

    if(!weight > 0 || breed == null){
      alert('Weight or Breed is not added.');
      return;
    }
  $('.my-loader').addClass('active');
 $('#scoop-output').css('visibility', 'hidden');

 setTimeout(() => {
   $('#scoop-output').css('visibility', 'visible');
   let scoopText = '';  
 
   if (weight <= 25) {
     scoopText = 'No of scoop: <strong>1</strong>';
   } else if (weight >= 26 && weight <= 75) {
     scoopText = 'No of scoop: <strong>2</strong>';
   } else if (weight >= 76 && weight <= 100) {
     scoopText = 'No of scoop: <strong>3</strong>';
   } else {
     scoopText = 'No of scoop: <strong>4</strong>';
   }
   $('#scoop-output').html(scoopText);
   $('.my-loader').removeClass('active');
 }, 1000);  
    
    
  })

  $('.auto-fill-box .form-check-input').on('click', function () {
      let index = $('.product-form__input--pill input').filter(':checked').index('.product-form__input--pill input');
      if($(this).is(':checked')){
        $(`.purchase__plans .shopify_subscriptions_app_block_container > *`).eq(index).find('input').eq(1).parent().click();
      } else {
        $(`.purchase__plans .shopify_subscriptions_app_block_container > *`).eq(index).find('input').eq(0).parent().click();
      }
  })

  // for home banner images flip
  if(window.location.pathname == '/'){
    var rotation = 180;
    let increasing = true;
    setInterval(()=> {
        if($('.flip-faces').hasClass('active')) {
            $('.flip-faces').removeClass('active');
            $('.flip-faces').css('transform', `rotateY(${rotation}deg)`);
        } else {
            $('.flip-faces').css('transform', `rotateY(${rotation}deg)`);
            $('.flip-faces').addClass('active');
        }
        changeImage();
      
        if (increasing) {
            rotation += 180;
            if (rotation >= 1000) {
                increasing = false;
            }
        } else {
            rotation -= 180;
            if (rotation <= 0) {
                increasing = true;
            }
        }
        
    }, 5000);
  
    function changeImage(){
        $('.flip-faces').each((index, item)=>{
          
          if($(item).children().length >2){
             const dNoneElements = $(item).find('.extra-faces');
            const randomIndex = Math.floor(Math.random() * dNoneElements.length);
            const randomElement = dNoneElements.eq(randomIndex);
  
            if(!$(item).hasClass('active')) {
                $(item).find('.front-face').attr('src', randomElement.attr('src'));
            } else {
                $(item).find('.back-face').attr('src', randomElement.attr('src'));
            }
          }
        })
    }
  }


  // for about video playback
  $('.thumbnail-overlay').on('click', function () {
      $(this).parent().find('.about-video').each(function() {
          if (this.paused) {
              this.play();
              $(this).parent().find('.thumbnail-overlay').css('opacity', '0');
          } else {
              $(this).parent().find('.thumbnail-overlay').css('opacity', '1');
              this.pause();
          }
      });
  });

  // science tabs
  $('.science-main-tabs .tab-single-item').on('click', function(){
      $('.science-main-tabs .tab-single-item').removeClass('active');
      $(this).addClass('active');
      $('.science-tab-cnt-wrapper .tab-cnt-single').removeClass('active');
      $('.science-tab-cnt-wrapper .tab-cnt-single').eq($(this).index()).addClass('active');
  })

  $('.science-inner-tab').on('change', function() {
      const selectedIndex = $(this).prop('selectedIndex');

      $(this).parent().find('.science-inner-tab-cnt-wrap .inner-tab-cnt-single').removeClass('active');
      $(this).parent().find('.science-inner-tab-cnt-wrap .inner-tab-cnt-single').eq(selectedIndex).addClass('active');
  });


  if(window.innerWidth <=768){
    $('.section-4').css('margin-bottom', `${$('.science-tab-cnt-wrapper .tab-cnt-single').outerHeight()}px`)
    $(window).on('resize', function(){
      $('.section-4').css('margin-bottom', `${$('.science-tab-cnt-wrapper .tab-cnt-single').outerHeight()}px`)
    })
  }
  


})



// add to cart
// $(document).ready(function () {
//     $('.product-form__buttons button').on('click', function(e){
//       e.preventDefault();
//       $(this).html('<span>Please wait...</span>');
      
//       let productID = $(this).closest('form').find(".product-variant-id").val();
//       let quantity = 1;
//       let index = $('.product-form__input--pill input').filter(':checked').index('.product-form__input--pill input');
//       let sellingId = $(`.purchase__plans .shopify_subscriptions_app_block_container > *`).eq(index).find('input:checked:last').data('selling-plan-id');
//       let items = [];
      
//       items.push({
//           id: productID,
//           selling_plan: sellingId,
//           quantity: quantity,
//       });
      
//       // Clear the cart first
//       $.ajax({
//         type: 'POST',
//         url: '/cart/clear.js',
//         success: function() {
//           // Add products to the cart
//           $.ajax({
//             type: 'POST',
//             url: '/cart/add.js',
//             dataType: 'json',
//             contentType: 'application/json',
//             data: JSON.stringify({ items: items }),
//             success: function() {
//               $.ajax({
//               type: 'POST',
//               url: '/cart/update.js',
//               dataType: 'json',
//               contentType: 'application/json',
//               success: function() {
//                 // Apply discount code
//                 // window.location.href = '/checkout';
//               }
//             });
//             },
//             error: function(xhr, status, error) {
//               console.error('Error clearing the cart:', xhr.responseText);
//             }
//           });
//         },
//       });
//     });
// });
// end  =====







// -----------Benefits of 'Everyday One------------

function showContent(tabId) {
    // Hide all tab content
    const contents = document.querySelectorAll('.tab-content');
    contents.forEach(content => content.classList.remove('active'));

    // Show the selected tab content
    document.getElementById(tabId).classList.add('active');

    // Remove 'active' class from all buttons
    const tabButtons = document.querySelectorAll('.tabs button');
    tabButtons.forEach(button => button.classList.remove('active'));

      
    // Add 'active' class to the clicked button
    const activeButton = document.querySelector(`.tabs button[data-tab="${tabId}"]`);
    if (activeButton) {
        activeButton.classList.add('active');
    }

}





// -------------------calculate------------

function calculateDosage() {
    const weight = document.getElementById('dog-weight').value;
    const scoopResult = document.getElementById('scoop-result');
    let scoops;

    if (weight < 25) {
        scoops = 1;
    } else if (weight >= 25 && weight <= 75) {
        scoops = 2;
    } else if (weight > 75 && weight <= 100) {
        scoops = 3;
    } else {
        scoops = 4;
    }

    scoopResult.textContent = `No of scoop: ${scoops}`;
}


// -------------slider-carousel---------------




// ---------------Introducing-Everyday One---------
$(document).ready(function () {
  
    $('.dog-images-carousel').owlCarousel({
        stagePadding: 12,
        margin:12,
        loop: true,
        nav: true,
        dots: false,  
        navText:[' <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.29566 6.65226L7.22441 0.723507C7.46642 0.482933 7.7938 0.3479 8.13504 0.3479C8.47628 0.3479 8.80365 0.482933 9.04566 0.723507C9.16673 0.843585 9.26282 0.986444 9.3284 1.14385C9.39397 1.30125 9.42773 1.47008 9.42773 1.64059C9.42773 1.81111 9.39397 1.97993 9.3284 2.13734C9.26282 2.29474 9.16673 2.4376 9.04566 2.55767L3.10399 8.47351C2.98293 8.59359 2.88684 8.73644 2.82126 8.89385C2.75568 9.05125 2.72192 9.22008 2.72192 9.39059C2.72192 9.56111 2.75568 9.72993 2.82126 9.88734C2.88684 10.0447 2.98293 10.1876 3.10399 10.3077L9.04566 16.2235C9.28889 16.465 9.42621 16.7933 9.42742 17.136C9.42863 17.4788 9.29363 17.808 9.05212 18.0512C8.81061 18.2944 8.48236 18.4318 8.1396 18.433C7.79684 18.4342 7.46764 18.2992 7.22441 18.0577L1.29566 12.1289C0.570001 11.4024 0.162403 10.4175 0.162403 9.39059C0.162403 8.36371 0.570001 7.37882 1.29566 6.65226Z" fill="#56C271"/> </svg> ', ' <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.70434 6.65226L2.77559 0.723507C2.53358 0.482933 2.2062 0.3479 1.86496 0.3479C1.52372 0.3479 1.19635 0.482933 0.954338 0.723507C0.833273 0.843585 0.73718 0.986444 0.671604 1.14385C0.606028 1.30125 0.572266 1.47008 0.572266 1.64059C0.572266 1.81111 0.606028 1.97993 0.671604 2.13734C0.73718 2.29474 0.833273 2.4376 0.954338 2.55767L6.89601 8.47351C7.01707 8.59359 7.11316 8.73644 7.17874 8.89385C7.24432 9.05125 7.27808 9.22008 7.27808 9.39059C7.27808 9.56111 7.24432 9.72993 7.17874 9.88734C7.11316 10.0447 7.01707 10.1876 6.89601 10.3077L0.954338 16.2235C0.711113 16.465 0.57379 16.7933 0.572579 17.136C0.571367 17.4788 0.706368 17.808 0.947881 18.0512C1.18939 18.2944 1.51764 18.4318 1.8604 18.433C2.20316 18.4342 2.53236 18.2992 2.77559 18.0577L8.70434 12.1289C9.43 11.4024 9.8376 10.4175 9.8376 9.39059C9.8376 8.36371 9.43 7.37882 8.70434 6.65226Z" fill="#56C271"/> </svg> '],
        responsive: {
            0: { items: 1,autoWidth: true } ,
            600: { items: 1  },
            1280: { items: 2 }
        }
    });

    $('.hero-banner-carousel').owlCarousel({
        loop: true,
        nav: false,
        autoplay: true,
        responsive: {
            0: {
                items: 1 // Always show 1 item
            },
            600: {
                items: 1 // Always show 1 item
            },
            1000: {
                items: 1 // Always show 1 item
            }
        },
      onInitialized: function () {
       setTimeout(function () {
                $('.hero-banner-carousel').trigger('refresh.owl.carousel');
            }, 100);  // Forces re-render
        }
    });
  
    $('.image-carousels').owlCarousel({
        loop: true,
        margin: 16,
        center: true,
        nav: true,
  
        responsive: {
            0: { items: 3,autoWidth: true } ,
            
           768: { items: 3,autoWidth: true  },
           
            1280: { items: 5 }
        },
        onInitialized: function () {
            setTimeout(function () {
                $('.image-carousels').trigger('refresh.owl.carousel');
            }, 100);  // Forces re-render
        }
    });
 

  
    $('.imageCarousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        navText:[
        `<svg class="custom-prev-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="31" viewBox="0 0 32 31" fill="none">
<rect width="31" height="31" rx="15.5" transform="matrix(-1 0 0 1 31.375 0)" fill="#EEFDEF"/>
<path d="M11.4834 12.7616L17.4122 6.83288C17.6542 6.59231 17.9815 6.45728 18.3228 6.45728C18.664 6.45728 18.9914 6.59231 19.2334 6.83288C19.3545 6.95296 19.4506 7.09582 19.5161 7.25322C19.5817 7.41062 19.6155 7.57945 19.6155 7.74997C19.6155 7.92048 19.5817 8.08931 19.5161 8.24671C19.4506 8.40411 19.3545 8.54697 19.2334 8.66705L13.2917 14.5829C13.1707 14.703 13.0746 14.8458 13.009 15.0032C12.9434 15.1606 12.9097 15.3295 12.9097 15.5C12.9097 15.6705 12.9434 15.8393 13.009 15.9967C13.0746 16.1541 13.1707 16.297 13.2917 16.417L19.2334 22.3329C19.4766 22.5744 19.614 22.9026 19.6152 23.2454C19.6164 23.5882 19.4814 23.9174 19.2399 24.1606C18.9984 24.4038 18.6701 24.5411 18.3273 24.5424C17.9846 24.5436 17.6554 24.4086 17.4122 24.167L11.4834 18.2383C10.7577 17.5117 10.3501 16.5268 10.3501 15.5C10.3501 14.4731 10.7577 13.4882 11.4834 12.7616Z" fill="#56C271"/>
</svg>`,
        `<svg class="custom-next-icon" xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
<rect width="31" height="31" rx="15.5" fill="#EEFDEF"/>
<path d="M19.8916 12.7616L13.9628 6.83288C13.7208 6.59231 13.3935 6.45728 13.0522 6.45728C12.711 6.45728 12.3836 6.59231 12.1416 6.83288C12.0205 6.95296 11.9244 7.09582 11.8589 7.25322C11.7933 7.41062 11.7595 7.57945 11.7595 7.74997C11.7595 7.92048 11.7933 8.08931 11.8589 8.24671C11.9244 8.40411 12.0205 8.54697 12.1416 8.66705L18.0833 14.5829C18.2043 14.703 18.3004 14.8458 18.366 15.0032C18.4316 15.1606 18.4653 15.3295 18.4653 15.5C18.4653 15.6705 18.4316 15.8393 18.366 15.9967C18.3004 16.1541 18.2043 16.297 18.0833 16.417L12.1416 22.3329C11.8984 22.5744 11.761 22.9026 11.7598 23.2454C11.7586 23.5882 11.8936 23.9174 12.1351 24.1606C12.3766 24.4038 12.7049 24.5411 13.0477 24.5424C13.3904 24.5436 13.7196 24.4086 13.9628 24.167L19.8916 18.2383C20.6173 17.5117 21.0249 16.5268 21.0249 15.5C21.0249 14.4731 20.6173 13.4882 19.8916 12.7616Z" fill="#56C271"/>
</svg>`
    ], 
        dots: false,
        autoplay: false,
        autoplayTimeout: 3000,
        items: 1
    });
});



$(document).ready(function () {
    $('.Happy-Pups-box').owlCarousel({
        loop: true,              // Enable looping
        margin: 24,              // Set margin between items
        nav: true,               // Enable navigation buttons (prev/next)
        navText:[
        `<svg class="custom-prev-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="31" viewBox="0 0 32 31" fill="none">
<rect width="31" height="31" rx="15.5" transform="matrix(-1 0 0 1 31.375 0)" fill="#EEFDEF"/>
<path d="M11.4834 12.7616L17.4122 6.83288C17.6542 6.59231 17.9815 6.45728 18.3228 6.45728C18.664 6.45728 18.9914 6.59231 19.2334 6.83288C19.3545 6.95296 19.4506 7.09582 19.5161 7.25322C19.5817 7.41062 19.6155 7.57945 19.6155 7.74997C19.6155 7.92048 19.5817 8.08931 19.5161 8.24671C19.4506 8.40411 19.3545 8.54697 19.2334 8.66705L13.2917 14.5829C13.1707 14.703 13.0746 14.8458 13.009 15.0032C12.9434 15.1606 12.9097 15.3295 12.9097 15.5C12.9097 15.6705 12.9434 15.8393 13.009 15.9967C13.0746 16.1541 13.1707 16.297 13.2917 16.417L19.2334 22.3329C19.4766 22.5744 19.614 22.9026 19.6152 23.2454C19.6164 23.5882 19.4814 23.9174 19.2399 24.1606C18.9984 24.4038 18.6701 24.5411 18.3273 24.5424C17.9846 24.5436 17.6554 24.4086 17.4122 24.167L11.4834 18.2383C10.7577 17.5117 10.3501 16.5268 10.3501 15.5C10.3501 14.4731 10.7577 13.4882 11.4834 12.7616Z" fill="#56C271"/>
</svg>`,
        `<svg class="custom-next-icon" xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
<rect width="31" height="31" rx="15.5" fill="#EEFDEF"/>
<path d="M19.8916 12.7616L13.9628 6.83288C13.7208 6.59231 13.3935 6.45728 13.0522 6.45728C12.711 6.45728 12.3836 6.59231 12.1416 6.83288C12.0205 6.95296 11.9244 7.09582 11.8589 7.25322C11.7933 7.41062 11.7595 7.57945 11.7595 7.74997C11.7595 7.92048 11.7933 8.08931 11.8589 8.24671C11.9244 8.40411 12.0205 8.54697 12.1416 8.66705L18.0833 14.5829C18.2043 14.703 18.3004 14.8458 18.366 15.0032C18.4316 15.1606 18.4653 15.3295 18.4653 15.5C18.4653 15.6705 18.4316 15.8393 18.366 15.9967C18.3004 16.1541 18.2043 16.297 18.0833 16.417L12.1416 22.3329C11.8984 22.5744 11.761 22.9026 11.7598 23.2454C11.7586 23.5882 11.8936 23.9174 12.1351 24.1606C12.3766 24.4038 12.7049 24.5411 13.0477 24.5424C13.3904 24.5436 13.7196 24.4086 13.9628 24.167L19.8916 18.2383C20.6173 17.5117 21.0249 16.5268 21.0249 15.5C21.0249 14.4731 20.6173 13.4882 19.8916 12.7616Z" fill="#56C271"/>
</svg>`
    ],  
        dots: false,             // Disable dots navigation
        autoplay: false,          // Enable autoplay
        autoplayTimeout: 3000,   // Set autoplay interval (in ms)
        autoWidth: true,
        responsive: {
            0: {
                items: 2,autoWidth: true, margin: 10
            },
            768: {
                items: 2
            },
            1000: {
                items: 3
            },
            1360: {
                items: 4
            },
            1400: {
                items: 5
            }
        },
onInitialized: function () {
            setTimeout(function () {
                $('.Happy-Pups-box').trigger('refresh.owl.carousel');
            }, 100);  // Forces re-render
        }
    });
});



$(document).ready(function () {
    $('.parents-saying-carousel').owlCarousel({
        loop: true,          // Enable looping
        margin: 10,          // Set margin between items
        nav: true,
        navText: [ `<svg class="custom-prev-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="31" viewBox="0 0 32 31" fill="none">
<rect width="31" height="31" rx="15.5" transform="matrix(-1 0 0 1 31.375 0)" fill="#EEFDEF"/>
<path d="M11.4834 12.7616L17.4122 6.83288C17.6542 6.59231 17.9815 6.45728 18.3228 6.45728C18.664 6.45728 18.9914 6.59231 19.2334 6.83288C19.3545 6.95296 19.4506 7.09582 19.5161 7.25322C19.5817 7.41062 19.6155 7.57945 19.6155 7.74997C19.6155 7.92048 19.5817 8.08931 19.5161 8.24671C19.4506 8.40411 19.3545 8.54697 19.2334 8.66705L13.2917 14.5829C13.1707 14.703 13.0746 14.8458 13.009 15.0032C12.9434 15.1606 12.9097 15.3295 12.9097 15.5C12.9097 15.6705 12.9434 15.8393 13.009 15.9967C13.0746 16.1541 13.1707 16.297 13.2917 16.417L19.2334 22.3329C19.4766 22.5744 19.614 22.9026 19.6152 23.2454C19.6164 23.5882 19.4814 23.9174 19.2399 24.1606C18.9984 24.4038 18.6701 24.5411 18.3273 24.5424C17.9846 24.5436 17.6554 24.4086 17.4122 24.167L11.4834 18.2383C10.7577 17.5117 10.3501 16.5268 10.3501 15.5C10.3501 14.4731 10.7577 13.4882 11.4834 12.7616Z" fill="#56C271"/>
</svg>`,
           `<svg class="custom-next-icon" xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
<rect width="31" height="31" rx="15.5" fill="#EEFDEF"/>
<path d="M19.8916 12.7616L13.9628 6.83288C13.7208 6.59231 13.3935 6.45728 13.0522 6.45728C12.711 6.45728 12.3836 6.59231 12.1416 6.83288C12.0205 6.95296 11.9244 7.09582 11.8589 7.25322C11.7933 7.41062 11.7595 7.57945 11.7595 7.74997C11.7595 7.92048 11.7933 8.08931 11.8589 8.24671C11.9244 8.40411 12.0205 8.54697 12.1416 8.66705L18.0833 14.5829C18.2043 14.703 18.3004 14.8458 18.366 15.0032C18.4316 15.1606 18.4653 15.3295 18.4653 15.5C18.4653 15.6705 18.4316 15.8393 18.366 15.9967C18.3004 16.1541 18.2043 16.297 18.0833 16.417L12.1416 22.3329C11.8984 22.5744 11.761 22.9026 11.7598 23.2454C11.7586 23.5882 11.8936 23.9174 12.1351 24.1606C12.3766 24.4038 12.7049 24.5411 13.0477 24.5424C13.3904 24.5436 13.7196 24.4086 13.9628 24.167L19.8916 18.2383C20.6173 17.5117 21.0249 16.5268 21.0249 15.5C21.0249 14.4731 20.6173 13.4882 19.8916 12.7616Z" fill="#56C271"/>
</svg>`], 
        dots: false,        // Disable navigation buttons
        autoplay: false,
        autoplayTimeout: 3000, // Set autoplay interval (in ms)
        responsive: {
            0: {
                items: 1
            },
            1000: {
                items: 2
            },
            1380: {
                items: 3
            }
        },
onInitialized: function () {
            setTimeout(function () {
                $('.parents-saying-carousel').trigger('refresh.owl.carousel');
            }, 100);  // Forces re-render
        }
    });
});

$(document).ready(function () {
    $('.dog-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        autoplay: false,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1 // Always show 1 item
            },
            600: {
                items: 1 // Always show 1 item
            },
            1000: {
                items: 1 // Always show 1 item
            }
        },
onInitialized: function () {
            setTimeout(function () {
                $('.dog-carousel').trigger('refresh.owl.carousel');
            }, 100);  // Forces re-render
        }
    }); 
    
});

$(window).on('load', function () { 
$('.hero-section-carousel').owlCarousel({
        loop: true,              // Enable looping
        margin: 10,              // Set margin between items
        nav: false,               // Enable navigation buttons (prev/next)
        dots: false,             // Disable dots navigation
        autoplay: true,          // Enable autoplay
        autoplayTimeout: 3000,   // Set autoplay interval (in ms)
        responsive: {
            0: {
                items: 3, autoWidth: true ,center:true    // Show 1 item for screens 0px and up
            }
        },
onInitialized: function () {
            setTimeout(function () {
                $('.hero-section-carousel').trigger('refresh.owl.carousel');
            }, 100);  // Forces re-render
        }
    });
setTimeout(function () {
        $('.hero-section-carousel').css('opacity', '1');
    }, 200);

});
// ---------------sidebar-js---------------------------------
function openNav() {
    document.getElementById("mySidepanel").style.left = "0%";
}
/* Set the width of the sidebar to 0 (hide it) */
function closeNav() {
    document.getElementById("mySidepanel").style.left = "100%";
}

// document.addEventListener('DOMContentLoaded', function() {
//     const quantityInput = document.querySelector('.product-variant-id');
//     const priceElement = document.getElementById('button-price');
//     const submitButton = document.getElementById('ProductSubmitButton-{{ section_id }}');
//     const basePrice = parseFloat(submitButton.getAttribute('data-price'));

//     function updateButtonPrice() {
//       const quantity = parseInt(quantityInput.value) || 1; // Default to 1 if invalid
//       const updatedPrice = basePrice * quantity;
//       priceElement.textContent = Shopify.formatMoney(updatedPrice, "{{ shop.money_format }}");
//     }

//     quantityInput.addEventListener('change', updateButtonPrice);
//     quantityInput.addEventListener('input', updateButtonPrice);
//   });